import React, { useContext } from 'react';
import CustomerFullInfoState from './customerFullInfoState/CustomerFullInfoState';
import CustomerFullInfoModal from './components/CustomerFullInfoModal/CustomerFullInfoModal';
import ModalLayout from 'components/ModalLayout';
import { CustomersContext, ICustomersContext } from '../Customers/customersState/customersContext';

const CustomerFullInfoPage: React.FC = () => {
	const { fullInfoData, setFullInfoData } = useContext<ICustomersContext>(CustomersContext);

	const handleClose = () => {
		setFullInfoData('', undefined);
	};

	return (
		<CustomerFullInfoState>
			<ModalLayout isVisible={!!fullInfoData.id} setIsShowModal={handleClose}>
				<CustomerFullInfoModal />
			</ModalLayout>
		</CustomerFullInfoState>
	);
};

export default CustomerFullInfoPage;
